import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const faqData = [
  {
    question: "¿Qué tipo de casos atienden?",
    answer: "Atendemos una amplia variedad de asuntos legales, siempre evaluando cada caso de forma individual. Nuestro enfoque es entender tu situación, analizarla con cuidado y determinar la mejor estrategia legal para proteger tus intereses."
  },
  {
    question: "¿Cómo sé si mi caso puede tener una solución?",
    answer: "Cada situación legal es distinta. Por eso, el primer paso siempre es escucharte. A partir de ahí, analizamos los hechos y te damos una orientación clara y honesta sobre las opciones legales disponibles para tu caso."
  },
  {
    question: "¿Qué tan involucrado estaré en el proceso?",
    answer: "Creemos en una comunicación clara y constante. Te mantenemos informado en cada etapa importante del proceso y resolvemos tus dudas para que siempre sepas qué está ocurriendo y por qué se toman ciertas decisiones."
  },
  {
    question: "¿Atienden casos urgentes?",
    answer: "Sí. Entendemos que muchos asuntos legales no pueden esperar. Si tu situación es urgente, hacemos todo lo posible por atenderte con rapidez y brindarte una orientación inmediata."
  },
  {
    question: "¿Cómo es el primer contacto con el despacho?",
    answer: "El primer contacto es sencillo y sin complicaciones. Nos escribes, te escuchamos y te orientamos sobre los siguientes pasos. Nuestro objetivo es que te sientas acompañado desde el primer momento."
  },
  {
    question: "¿Qué los diferencia de otros despachos?",
    answer: "Nos distingue el trato humano, la atención personalizada y el compromiso real con cada caso. No tratamos asuntos como números: cada cliente recibe un análisis serio, honesto y profesional."
  },
  {
    question: "¿Por qué debería confiarles mi caso?",
    answer: "Porque entendemos la importancia de lo que estás enfrentando. Trabajamos con ética, responsabilidad y enfoque estratégico, buscando siempre la mejor solución legal para tu situación."
  }
];

const FAQ = () => {
  return (
    <section id="faq" className="py-20 md:py-32 bg-[rgb(var(--bg-primary))]">
      <div className="container mx-auto px-6 md:px-12 max-w-4xl">
        <div className="text-center mb-16">
          <h2 className="heading-1 mb-6 text-[rgb(var(--burgundy-primary))]">
            Las dudas más comunes antes de tomar una decisión legal
          </h2>
          <div className="w-20 h-1 bg-[rgb(var(--burgundy-primary))] mx-auto mb-6"></div>
          <p className="body-large text-[rgb(var(--text-secondary))] max-w-2xl mx-auto">
            Sabemos que tomar una decisión legal puede generar incertidumbre. Aquí respondemos las preguntas más frecuentes de nuestros clientes.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqData.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-[rgb(var(--bg-secondary))] border border-[rgb(var(--border-light))] px-6 py-2 rounded-none transition-all hover:shadow-md"
            >
              <AccordionTrigger className="text-left heading-3 text-[rgb(var(--text-primary))] hover:text-[rgb(var(--burgundy-primary))] py-6 hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="body-regular text-[rgb(var(--text-secondary))] pt-2 pb-6 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* CTA after FAQ */}
        <div className="text-center mt-16">
          <p className="body-large text-[rgb(var(--text-primary))] mb-6">
            ¿Tienes una pregunta diferente? Estamos aquí para ayudarte.
          </p>
          <button
            onClick={() => window.open('https://wa.me/527773306335', '_blank')}
            className="inline-flex items-center gap-3 px-10 py-4 bg-[rgb(var(--burgundy-primary))] text-white hover:bg-[rgb(var(--burgundy-dark))] transition-smooth button-text shadow-lg hover:shadow-xl rounded-none"
          >
            Contáctanos por WhatsApp
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
